import React, { useState } from "react";
import UpperNav from "./UpperNav";

const links = [["Home", "#home"], ["AI Assistant", "#ai-assistant"], ["Solutions", "#services"], ["FBRConnect", "https://fbrconnect.visiosol.tech"], ["Work", "#case-studies"], ["Contact", "#contact"]];

const Header = () => {
  const [open, setOpen] = useState(false);
  return <header id="navbar" className="site-header">
    <UpperNav />
    <div className="nav-bar"><div className="site-shell nav-inner">
      <nav className={open ? "nav-links is-open" : "nav-links"} aria-label="Main navigation">
        {links.map(([label, href]) => <a key={href} href={href} onClick={() => setOpen(false)}>{label}{label === "FBRConnect" && <span className="external-mark" aria-hidden="true">↗</span>}</a>)}
      </nav>
      <a className="nav-cta" href="#contact">Start a project <span>↗</span></a>
      <button className="menu-button" onClick={() => setOpen(!open)} aria-label="Toggle menu" aria-expanded={open}><span></span><span></span></button>
    </div></div>
  </header>;
};
export default Header;
